import { render, staticRenderFns } from "./PointsPopover.vue?vue&type=template&id=b7e8e528&scoped=true"
import script from "./PointsPopover.vue?vue&type=script&lang=js"
export * from "./PointsPopover.vue?vue&type=script&lang=js"
import style0 from "./PointsPopover.vue?vue&type=style&index=0&id=b7e8e528&prod&lang=less"
import style1 from "./PointsPopover.vue?vue&type=style&index=1&id=b7e8e528&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e8e528",
  null
  
)

export default component.exports